import type { LoaderProps } from './Loader.types';
import classes from './Loader.module.css';
import { Text } from '../Text';

export const Loader = (props: LoaderProps) => {
    return (
        <div className={props.micAccess ? classes.root : ''}>
            <div className={props.micAccess ? classes.micloader : classes.loader} data-testid={`${props.id}-loader`}>
                <div className={classes.dot}></div>
                <div className={classes.dot}></div>
                <div className={classes.dot}></div>
                <div className={classes.dot}></div>
                <div className={classes.dot}></div>
            </div>
            {props.micAccess ? <>
                <p className={classes.topRight}>
                    <Text
                        text={`V204`}
                        fontWeight="medium"
                       variant="body"
                    />
                </p>
                <p className={classes['align-center']}>
                    <Text text="Checking microphone access" fontWeight="bold" variant="heading"/>
                </p>
                <p className={classes['align-center']}>
                    <Text text="Please allow access to your microphone" variant="body" />
                </p>
            </>
                : null}


        </div>

    );
};

Loader.displayName = 'Loader';
